<div class="area-filtro" [formGroup]="data.filtro">
  <div class="flex-column gap-30">
    <span class="font-12 weight-600">Documentos</span>

    <div class="flex-column gap-9">
      <span class="font-12 weight-400" style="color: #3D3C3C">Empresas</span>
      @for (empresa of data.coligadas; track empresa.id) {
        <span class="font-11 weight-700" [style.background-color]="verificarSelecionado(coligadaSelecionada, empresa) ? '#BDD6D9' : ''"
              style="color: #3D3C3C; margin-left: 30px; padding: 5px" (click)="adicionarNoFiltro(empresa, 'coligada'); coligadaSelecionada = empresa">{{ empresa.nome }}</span>
      }
    </div>

    <div class="flex-column gap-9">
      <span class="font-12 weight-400" style="color: #3D3C3C">Tipo de Documento</span>
      @for (tipoDocumento of data.tiposDocumentos; track tipoDocumento.id) {
        <span class="font-11 weight-700" [style.background-color]="verificarSelecionado(tipoDocumentoSelecionada, tipoDocumento) ? '#BDD6D9' : ''"
              style="color: #3D3C3C; margin-left: 30px; padding: 5px" (click)="adicionarNoFiltro(tipoDocumento, 'tipoDocumento'); tipoDocumentoSelecionada = tipoDocumento">{{ tipoDocumento.nome }}</span>
      }
    </div>

    <div class="flex-column gap-9">
      <span class="font-12 weight-400" style="color: #3D3C3C">Data</span>
      <mat-form-field appearance="outline">
        <mat-label>Data</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate formControlName="dataInicial" placeholder="Data Inicial">
          <input matEndDate formControlName="dataFinal" placeholder="Data Final">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>

    <div class="flex-column gap-9">
      <span class="font-12 weight-400" style="color: #3D3C3C">Parceiro</span>
      @for (parceiro of data.parceiros; track parceiro.id) {
        <span class="font-11 weight-700" [style.background-color]="verificarSelecionado(parceiroSelecionada, parceiro) ? '#BDD6D9' : ''"
              style="color: #3D3C3C; margin-left: 30px; padding: 5px" (click)="adicionarNoFiltro(parceiro, 'parceiro'); parceiroSelecionada = parceiro">{{ parceiro.nome }}</span>
      }
    </div>
  </div>

  <button mat-flat-button class="btn-filtro" (click)="filtrar()">
    <mat-icon>filter_list</mat-icon>
    <span class="font-12 weight-700">Filtrar</span>
  </button>
</div>
